export default ({ updateSubdeployment, history, deploymentId, subdeploymentId, onSuccess }) => values => {
  const updatedData = updateSubdeployment({
    variables: {
      subdeploymentInput: values,
      history,
      deploymentId,
      subdeploymentId
    },
  });

  return updatedData.then(result => {
    const subdeployment = result?.data?.updateSubdeployment;
    if (subdeployment && subdeployment.id) {
      onSuccess();
    }
  });
};
